/**
 * DEV-2330. Результат задачи: поле при закрытии галочкой, показ у закрытых,
 * модалка на борде. Строки общие для карточки сделки, карточки клиента и
 * раздела «Задачи», поэтому не в tasksBoard.ts.
 */
export const taskResultMessages = {
  ru: {
    tasks: {
      result: {
        label: 'Результат',
        placeholder: 'Что сделано по задаче',
        requiredHint: 'Обязательно для задачи воронки',
        optionalHint: 'Необязательно',
        complete: 'Выполнить',
        requiredError: 'Для задачи воронки нужен результат',
        shown: 'Результат: {result}',
        autoClosed: 'Закрыта автоматически',
        modalTitle: 'Выполнить задачу',
        column: 'Результат',
      },
    },
  },
  en: {
    tasks: {
      result: {
        label: 'Result',
        placeholder: 'What was done',
        requiredHint: 'Required for a pipeline task',
        optionalHint: 'Optional',
        complete: 'Complete',
        requiredError: 'A pipeline task needs a result',
        shown: 'Result: {result}',
        autoClosed: 'Closed automatically',
        modalTitle: 'Complete the task',
        column: 'Result',
      },
    },
  },
  vn: {
    tasks: {
      result: {
        label: 'Kết quả',
        placeholder: 'Đã làm gì cho nhiệm vụ',
        requiredHint: 'Bắt buộc với nhiệm vụ của quy trình',
        optionalHint: 'Không bắt buộc',
        complete: 'Hoàn thành',
        requiredError: 'Nhiệm vụ của quy trình cần có kết quả',
        shown: 'Kết quả: {result}',
        autoClosed: 'Đã đóng tự động',
        modalTitle: 'Hoàn thành nhiệm vụ',
        column: 'Kết quả',
      },
    },
  },
}
